import React, { useMemo } from "react";
import { AiOutlineEye } from "react-icons/ai";
import ServerDataGrid from "../../../../../views/pages/manage/common/data-grid/ServerDataGrid";
import ReceiptStatusChip from "../../components/ReceiptStatusChip";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getUpdatedTime } from "views/pages/manage/employeeManagement/userProfile/helper";
import { ReactComponent as EditIcon } from 'assets/img/svg/Edit2.svg';
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";


// --- Helpers ---
const formatDate = (dateString) => {
  if (!dateString) return "-";
  return `${getFormattedDate(dateString)} at ${getUpdatedTime(dateString)}`;
};



const DepositedSlipsList = ({
  rows,
  loading,
  pagination,
  onPageChange,
  onPageSizeChange,
  onViewSlip,
  onEditReceipt
}) => {
  const handleView = (row) => {
    if (onViewSlip) {
      onViewSlip(row);
    } else {
      console.log("View Slip", row);
    }
  };
  const navigateToGivenPath = useNavigateToGivenPath();

  const columns = useMemo(
    () => [
      {
        key: "businessArea",
        label: "BU",
        width: 80,
        sortable: true,
      },

      {
        key: "bankName",
        label: "Bank Name",
        width: 140,
        sortable: true,
      },
      {
        key: "accountNumber",
        label: "Acc. Number",
        width: 140,
        sortable: true,
      },
      {
        key: "depositSlipId",
        label: "Deposit slip ID",
        width: 180,
        render: (value) => (
          <span>
            {value}
          </span>
        ),
      },
      {
        key: "slipS3Key", // Using this key for the 'View' button column as per old config
        label: "Deposit slip",
        width: 120,
        align: "center",
        render: (_, row) => (
          <button
            className="btn btn-primary btn-sm"
            style={{ fontSize: "12px", padding: "4px 12px" }}
            onClick={() => handleView(row)}
          >
            View
          </button>
        ),
      },
        {
        key: "depositSlipNumber",
        label: "Deposit Slip No.",
        width: 140,
        sortable: false,
      },
       {
        key: "sapDocumentNumber",
        label: "SAP Reference No.",
        width: 140,
        sortable: false,
      },
      
      {
        key: "cashier",
        label: "Cashier",
        width: 100,
      },
      {
        key: "totalCount",
        label: "Total Count",
        width: 120,
        align: "center",
      },

      {
        key: "updatedOn",
        label: "Last updated on",
        width: 220,
        render: (value) => formatDate(value),
      },
      {
        key: "approvedOn",
        label: "Approved On",
        width: 220,
        render: (value) => formatDate(value),
      },
      {
        key: "totalAmount",
        label: "Amt Collected",
        width: 160,
        align: "right",
        pinned: true, // Assuming you want status pinned like previous grids
        render: (value) => (
          <span style={{ color: "#1BA55C", fontWeight: 600 }}>
            {getFormattedAmount(value)}
          </span>
        ),
      },
      {
        key: "status",
        label: "Status",
        width: 150,
        pinned: true, // Assuming you want status pinned like previous grids
        render: (value, row) => <ReceiptStatusChip  status={value} remarks={row?.remarks} paymentType='cash'/>,
      },
      {
        key: "action",
        label: "Action",
        pinned: true,
        width: 80,
        align: "center",
        render: (_, row) => {
          const viewCashDepositRedirectUrl = `/admin/viewCashDepositApproval?depositSlipNo=${encodeURIComponent(row?.depositSlipId)}&businessAreaValue=${encodeURIComponent(row?.businessArea)}&cashReceiptId=${encodeURIComponent(row?.id)}&isBmApproval=${encodeURIComponent(true)}`
         return <span
            style={{
              cursor: "pointer",
              color: "#666",
              display: "flex",
              justifyContent: "center",
              gap: "12px",
            }}
            onClick={() => navigateToGivenPath(viewCashDepositRedirectUrl)}
          >
            <AiOutlineEye size={20}  />
            {row.status.includes("SENT_CORRECTION") && (
              <EditIcon onClick={() => onEditReceipt(row)} />
            )}
          </span>
      }},
      
    ],
    [onViewSlip]
  );

  return (
    <ServerDataGrid
      rows={rows}
      loading={loading}
      columns={columns}
      rowKey="id" // Ensure your data has a unique 'id' field, or change this
      pagination={pagination}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      selectable={false}
    />
  );
};

export default DepositedSlipsList;
